import quotation from '@/view/designer/quotation'
import quotationDetail from '@/view/designer/quotationDetail'
import quotationText from '@/view/designer/quotationText'
import quotationTextDetail from '@/view/designer/quotationTextDetail'
const designerRouter = [
  {
    path: '/designer/quotation.html',
    name: 'designer-quotation',
    component: quotation,
    meta: {
      title: '报价记录'
    }
  },
  {
    path: '/designer/quotationDetail.html',
    name: 'designer-quotation-detail',
    component: quotationDetail,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/designer/quotationText.html',
    name: 'designer-quotation-text',
    component: quotationText,
    meta: {
      title: '我的设计任务'
    }
  },
  {
    path: '/designer/quotationTextDetail.html',
    name: 'designer-quotationText-detail',
    component: quotationTextDetail,
    meta: {
      title: '订单详情'
    }
  },
]

export default designerRouter



// WEBPACK FOOTER //
// ./src/router/designer/designer.js